module.exports = __webpack_public_path__ + "static/media/heart.67a207d5.png";